import React, { useState, useEffect } from 'react';
import { Table, Space, Button, Card, Layout, Menu, Form, Input, Select, Switch  } from 'antd';
import {Await, Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios'; // Import axios library
import { EditOutlined } from '@ant-design/icons';

import Sidebar from '../../Side_Bar/Admin_Side_Bar';
const { Option } = Select;

const View_Edit_Contract_Page = () => {
  const [contract_data, setContractData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const mainUrl                       = "https://chatbot-summary-deployment-dot-fartech-yvqj.et.r.appspot.com/";
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${mainUrl}/getAllTable?tableName=Contract`);
        // const response2 = await fetch(`${mainUrl}/getAllTable?tableName=User`);

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const contract_data = await response.json();

        // Adding 'index' property to each object in the array
        const dataWithIndex = contract_data.map((item, index) => ({
          ...item,
          index: index + 1, // Assuming you want to start the index from 1
        }));

        setContractData(dataWithIndex);
        setIsLoading(false);

      } catch (error) {
        console.error('Error fetching table data:', error);
        throw error;
      }
    };

    fetchData();

  }, [])

  const [form] = Form.useForm();

  // Columns for the table
  const columns = [
        {
          title: 'SUBSCRIPTION ID',
          dataIndex: 'contract_id',
          key: 'contract_id',
          render: (text, record) => {
              return text
          },
      },
      {
        title: 'PACKAGE NAME',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          return text
        },
      },
      {
        title: 'PACKAGE TYPE',
        dataIndex: 'type',
        key: 'type',
        render: (text, record) => {
          return text;
        },
      },
      {
          title: 'END DATE',
          dataIndex: 'end_date',
          key: 'end_date',
          render: (text, record) => {
            return text.split("T")[0];
          },
      },
      {
          title: 'SUBSCRIPTION STATUS',
          dataIndex: 'is_active',
          key: 'is_active',
          render: (text, record) => {
            return (
              <Form.Item 
              name={`is_active_${record.index}`} 
              valuePropName="checked"
              initialValue={(text === 1)? true:false}
              >
                <Switch 
                onChange={() => handleSwitchChange(record)} 
                />
              </Form.Item>
            );
          },
      },
  ];

  const handleSwitchChange = (record) => {
    const isEnabled = form.getFieldValue(`is_active_${record.index}`);

    const updatedData = {
      contract_id: record.contract_id,
      is_active: isEnabled
    };
    

    try{
      axios.put(mainUrl + `/updateContractStatus`, updatedData)
      .then(response => {
        console.log('Updated Company Cost:', response.data);
      })
      .catch(error => {
        console.error('Error updating contract status:', error.response ? error.response.data : error.message);
      });

    } catch (error) {
      console.error('Error contract status:', error);
    } 

  };

  columns.push({
    title: '',
    dataIndex: 'actions',
    key: 'actions',
    render: (_, record) => {  
      return (
        <>
          <Form.Item>
            <Button 
              onClick={() => handleEdit(record)} 
              style={{color: 'black'}}
              icon={<EditOutlined />}  // Replace EditOutlined with the correct import
            />
          </Form.Item>
        </>
      )
    },
  })

  const handleEdit = (record, row_index) => {
    form.setFieldsValue({
      contract_id: record.contract_id
    });
    navigate('/edit_contract', { state: { contract_id: record.contract_id } });
  };

  const onAddCustomerClick = () => {
    navigate('/add_contract');
  }

  if (isLoading) {
    return <p>Loading...</p>;
  }

  return (
    <Layout style={{ minHeight: '98vh' }}>
       <Sidebar location={location} />
       <Layout style={{ background: 'white'}}>
          <div 
          style={{ 
            maxWidth: '100%',
            maxHeight:"100%", 
            margin: '30px', 
            textAlign: 'center', 
            fontFamily: 'Helvetica, Arial, sans-serif' }}>
            <Card 
              title={<span style={{ fontSize: '20px', fontWeight: 'bold' }}>SUBSCRIPTION INFORMATION</span>} 
              style={{ maxWidth: '100%', maxHeight: "100%" }}
            >
              <div 
                style={{ 
                  display: 'flex', 
                  justifyContent: 'flex-end', 
                  alignItems: 'center',
                  marginBottom: "1%"}}>
                    <Button
                      style={{ 
                        height: "50px", 
                        background: "#00308F",
                        color: "white" }}
                        onClick={()=>{onAddCustomerClick()}}
                      >
                      + Add Subscription
                    </Button>
              </div>

              <div style={{ overflowX: 'auto' }}>
                <Form form = {form}>
                  <Table 
                  dataSource={contract_data} 
                  columns={columns}
                  scroll={{ x: 100, y: 800 }}
                    />
                </Form>
              </div>
            </Card>
          </div>
        </Layout>
      </Layout>
  );
};

export default View_Edit_Contract_Page;